import { Link } from "react-router-dom";

interface Props {
  to: string;
  name: string;
  type: string;
  icon?: React.ReactNode;
  defaultChildNav?: string;
  altRoute?: string[]; // when tab/menu selected, apply "selected" class
}

const Nav = (props: Props) => {
  let toPath = props.to;

  if (props.defaultChildNav) {
    toPath = toPath + "/" + props.defaultChildNav;
  }

  return (
    // Need to container/parent to structure properly, check global.scss
    <Link to={toPath}>
      <div
        data-route={
          props.altRoute ? props.to + "," + props.altRoute?.join(",") : props.to
        }
        className={`${props.type}-list transition-all`}
      >
        <div className="icon-holder"></div>
        <div className="">{props.name}</div>
      </div>
    </Link>
  );
};

export default Nav;
